import { render, staticRenderFns } from "./HotLine.vue?vue&type=template&id=0f03c180&scoped=true&"
import script from "./HotLine.vue?vue&type=script&lang=js&"
export * from "./HotLine.vue?vue&type=script&lang=js&"
import style0 from "./HotLine.vue?vue&type=style&index=0&id=0f03c180&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03c180",
  null
  
)

export default component.exports